<template>
  <page>
    <div>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xl3 lg6 xs6>
                        <v-autocomplete :items="tariff" v-model="filter.tariff" :label="label.tariff" item-text="label" item-value="value" :error-messages="errors.collect('filter.tariff')" data-vv-name="filter.tariff" :data-vv-as="label.tariff" clearable></v-autocomplete>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-autocomplete :items="buscls" v-model="filter.busCls" :label="label.busCls" item-text="label" item-value="value" :error-messages="errors.collect('filter.busCls')" data-vv-name="filter.busCls" :data-vv-as="label.busCls" clearable></v-autocomplete>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-autocomplete :items="benefit" v-model="filter.benefit" :label="label.benefit" item-text="label" item-value="value" :error-messages="errors.collect('filter.benefit')" data-vv-name="filter.benefit" :data-vv-as="label.benefit" clearable></v-autocomplete>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field v-model="filter.totTariff" :label="label.totTariff" :error-messages="errors.collect('totTariff')" data-vv-name="totTariff" :data-vv-as="label.totTariff" v-validate="'mask_decimal:2|mask_min_value:0|mask_max_value:99999999.99'"></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <cal-picker v-model="filter.effDate" :label="label.effDate" :data-vv-as="label.effDate" data-vv-name="effDate"></cal-picker>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                 <v-card-actions>
                  <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.native="doNew">
          New Tariff Premium<v-icon right>mdi-plus</v-icon>
        </v-btn>
        </v-card-title>
        <v-flex>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td class="text-xs-left">{{ row.item.busCls }} </td>
                <td class="text-xs-left">{{ row.item.tariff }} </td>
                <td class="text-xs-left">{{ row.item.benefit }} </td>
                <td class="text-xs-left">{{ row.item.totTariff }} </td>
                <td class="text-xs-left">{{ formatDate(row.item.effDate) }} </td>
                <td class="text-xs-left">{{ formatDate(row.item.expDate) }} </td>
                <td class="text-xs-left">{{ row.item.gap }} </td>
                <td class="table-action-header">
                  <table-action :rowData="row" query @query="doQuery(row.item)" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
        <confirm v-model="promptRemove" @ok="doDelete">
          <p>Are you sure you want to delete the Tariff Premium?</p>
          <div class="queryValue">Business Class: {{selectedTariffPrem.busCls}}<br/>
            Tariff: {{selectedTariffPrem.tariff}}<br/>
            Benefit: {{selectedTariffPrem.benefit}}<br/>
            Total Tariff: {{selectedTariffPrem.totTariff}}<br/>
            Effective Date: {{selectedTariffPrem.effDate}}<br/>
          </div>
        </confirm>
      </v-card>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'
import { formatPrice } from '@/utils/index'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'

export default {
  data() {
    return {
      label: {
        tariff: 'Tariff',
        busCls: 'Business Class',
        benefit: 'Benefit',
        totTariff: 'Total Tariff',
        effDate: 'Effective Date'
      },
      filter: {
        tariff: null,
        busCls: null,
        benefit: null,
        totTariff: null,
        effDate: null
      },
      toogleArray: [false],
      submitting: false,
      buscls: [],
      tariff: [],
      benefit: [],
      loading: false,
      totalItems: 0,
      headers: [
        { text: 'Business Class', align: 'left', value: 'busCls' },
        { text: 'Tariff', align: 'left', value: 'tariff' },
        { text: 'Benefit', align: 'left', value: 'benefit' },
        { text: 'Total Tariff', align: 'left', value: 'totTariff' },
        { text: 'Effective Date', align: 'left', value: 'effDate' },
        { text: 'Expiry Date', align: 'left', value: 'expDate' },
        { text: 'GAP', align: 'left', value: 'gap' },
        TableConst.tableActionHeader
      ],
      promptRemove: false,
      selectedTariffPrem: {
        tariff: null,
        busCls: null,
        benefit: null,
        totTarif: null,
        effDate: null
      },
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataListDropDown('buscls')
      this.getCommonDataListDropDown('tariff')
      this.getCommonDataListDropDown('benefit')
      this.fetchData(true)
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.tariffPremList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let messageFilters = clone(this.filter)

          if (messageFilters.effDate !== null && messageFilters.effDate !== '') {
            messageFilters.effDate = formatDisplayDateTime2(removeTime(messageFilters.effDate))
          }

          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), messageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((tariffPrem) => {
                const convertList = {
                  tariff: tariffPrem.tariff,
                  busCls: tariffPrem.busCls,
                  benefit: tariffPrem.benefit,
                  totTariff: formatPrice(tariffPrem.totTariff),
                  effDate: tariffPrem.effDate,
                  expDate: tariffPrem.expDate,
                  gap: tariffPrem.gap
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filter.busCls = null
      this.filter.tariff = null
      this.filter.benefit = null
      this.filter.totTariff = null
      this.filter.effDate = null
      this.fetchData(false)
    },
    doFilters() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doNew() {
      const commit = {
        tranMode: 'New',
        tariff: '',
        busCls: '',
        benefit: '',
        totTariff: '',
        effDate: ''
      }
      sessionStorage.setItem('tariffPrem', JSON.stringify(commit))
      this.$store.commit('TARIFF_PREM_COMMIT_KEY', commit)
      this.$router.push({ name: 'tarfPremDetail' })
    },
    doQuery(data) {
      const commit = {
        tranMode: 'Query',
        tariff: data.tariff,
        busCls: data.busCls,
        benefit: data.benefit,
        totTariff: data.totTariff,
        effDate: data.effDate
      }
      sessionStorage.setItem('tariffPrem', JSON.stringify(commit))
      this.$store.commit('TARIFF_PREM_COMMIT_KEY', commit)
      this.$router.push({ name: 'tarfPremDetail' })
    },
    doReview(data) {
      const commit = {
        tranMode: 'Review',
        tariff: data.tariff,
        busCls: data.busCls,
        benefit: data.benefit,
        totTariff: data.totTariff,
        effDate: data.effDate
      }
      sessionStorage.setItem('tariffPrem', JSON.stringify(commit))
      this.$store.commit('TARIFF_PREM_COMMIT_KEY', commit)
      this.$router.push({ name: 'tarfPremDetail' })
    },
    async doPromptRemove(data) {
      this.resetMessages()
      if (data) {
        try {
          const apiURI = this.menu.checkDeleteTariffPrem
          const expand = {
            busCls: data.busCls,
            tariff: data.tariff,
            benefit: data.benefit,
            totTariff: data.totTariff,
            effDate: formatDisplayDateTime2(removeTime(data.effDate))
          }
          await this.$http.get(expandURI(apiURI, expand))
          this.selectedTariffPrem.tariff = data.tariff
          this.selectedTariffPrem.busCls = data.busCls
          this.selectedTariffPrem.benefit = data.benefit
          this.selectedTariffPrem.totTariff = data.totTariff
          this.selectedTariffPrem.effDate = formatDisplayDate(data.effDate)
          this.promptRemove = true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fieldMessage(data)
            this.notify(data)
          }
        }
      }
    },
    doDelete() {
      this.resetMessages()
      if (this.selectedTariffPrem) {
        const apiURI = this.menu.deleteTariffPrem
        if (apiURI) {
          const expand = {
            busCls: this.selectedTariffPrem.busCls,
            tariff: this.selectedTariffPrem.tariff,
            benefit: this.selectedTariffPrem.benefit,
            totTariff: this.selectedTariffPrem.totTariff,
            effDate: this.selectedTariffPrem.effDate
          }
          this.$http
            .delete(expandURI(apiURI, expand))
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.doInit()
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.tariffPremParam.menu
    }
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin]
}
</script>
